import React, { useState } from "react";
import { DateTime } from "luxon";

const WeekCalendar = ({
  prevWeek,
  nextWeek,
  startDate,
  formatDateToDayMonth,
  newTimeWithslotsWeek,
  pitchWeekAvailability,
  getDayOfWeek,
  formatTimeRangespace,
  visiblePitches,
  selectedPitchName,
  isSlotAlreadyBooked,
  isSlotSelectedInCart,
  isSlotDeleatable,
  selectedDate,
  removeFromCart,
  handleBoxClick,
  selectedPitchIcon,
  singaporeTime,
}) => {
  const [hoveredPitch, setHoveredPitch] = useState(null);
  const [hoveredTimeRange, setHoveredTimeRange] = useState(null);
  const [hoveredDate, setHoveredDate] = useState(null);

  function formatDate(date) {
    if (!date) {
      return "";
    }

    if (!(date instanceof Date)) {
      date = new Date(date);
    }

    if (isNaN(date.getTime())) {
      return "";
    }

    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();
    return `${day} ${months[monthIndex]} ${year}`;
  }

  const getDurationDisplay = (timeRange) => {
  if (!timeRange || !timeRange.includes('-')) return { duration: 0, unit: 'hr' };

  const [startTime, endTime] = timeRange.split('-').map(t => t.trim());
  
  const convertToHours = (timeStr) => {
    const [time, period] = timeStr.split(' ');
    let [hours, minutes] = time.split(':').map(Number);
    
    if (period === 'PM' && hours !== 12) hours += 12;
    if (period === 'AM' && hours === 12) hours = 0;
    
    return hours + (minutes / 60);
  };

  const start = convertToHours(startTime);
  const end = convertToHours(endTime);
  
  let duration = end - start;
  if (duration < 0) duration += 24;
  
  duration = Math.round(duration * 100) / 100;
  const unit = duration === 1 ? 'hr' : 'hr';
  
  return { duration, unit };
};

function convertTo24HourFormat(timeRange) {
  const [startTime, endTime] = timeRange.split('-');
  const startTime24 = to24Hour(startTime);
  const endTime24 = to24Hour(endTime);
  
  // Calculate duration (using absolute value to ensure positive)
  const start = new Date(`2000-01-01T${startTime24}:00`);
  const end = new Date(`2000-01-01T${endTime24}:00`);
  const durationInHours = Math.abs((end - start) / (1000 * 60 * 60));
  const hourText = durationInHours === 1 ? 'hr' : 'hr';
  
  return (
    <span>
      {startTime24}-{endTime24} 
    </span>
  );
}
  
  function to24Hour(time) {
    const [timePart, modifier] = time.match(/(\d{1,2}:\d{2})(AM|PM)/i).slice(1, 3);
    let [hours, minutes] = timePart.split(':').map(Number);
  
    if (modifier.toUpperCase() === 'PM' && hours !== 12) {
      hours += 12;
    } else if (modifier.toUpperCase() === 'AM' && hours === 12) {
      hours = 0;
    }
  
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  }

  const getSingaporeTimeAsDateObject = () => {
    let singaporeTimeString = new Date().toLocaleString("en-US", {
      timeZone: "Asia/Singapore",
    });

    let [datePart, timePart] = singaporeTimeString.split(", ");
    let [month, day, year] = datePart.split("/");
    let [hours, minutes, seconds] = timePart.split(/[: ]/).map(Number);
    let period = timePart.split(" ")[1];

    if (period === "PM" && hours !== 12) {
      hours += 12;
    } else if (period === "AM" && hours === 12) {
      hours = 0;
    }

    let singaporeDate = new Date(year, month - 1, day, hours, minutes, seconds);
    return singaporeDate;
  };

  const parseTimeToSingapore = (timeStr, referenceDate) => {
    const [time, modifier] = timeStr.split(" ");
    let [hours, minutes] = time.split(":").map(Number);

    if (modifier === "PM" && hours !== 12) {
      hours += 12;
    } else if (modifier === "AM" && hours === 12) {
      hours = 0;
    }

    return referenceDate.set({ hour: hours, minute: minutes, second: 0 });
  };

  const isSlotDisabledByTodayTime = (
    slotTime,
    pitch,
    isWeekView = false,
    date = null
  ) => {
    if (!singaporeTime) {
      console.error("Singapore time is not set yet");
      return false;
    }

    let now = singaporeTime;
    let currentDate = isWeekView
      ? DateTime.fromJSDate(date).setZone("Asia/Singapore")
      : selectedDate
      ? DateTime.fromJSDate(selectedDate).setZone("Asia/Singapore")
      : now;

    // if (pitch) {
    //   const pitchHours = parseInt(pitch, 10);
    //   now = now.plus({ hours: pitchHours });
    // }

    const [startTime, endTime] = slotTime.split("-").map((time) => time.trim());
    const slotStartTime = parseTimeToSingapore(startTime, currentDate);

    return slotStartTime < now;
  };


   const isSlotInBufferPeriod = (
      slotTime,
      pitch,
      isWeekView = false,
      date = null
    ) => {
      if (!singaporeTime) {
        console.error("Singapore time is not set yet");
        return false;
      }
    
      // Use the fetched Singapore time
      const now = singaporeTime;
      let nowWithPitch = now;
    
      let currentDate = isWeekView
        ? DateTime.fromJSDate(date).setZone("Asia/Singapore")
        : selectedDate
        ? DateTime.fromJSDate(selectedDate).setZone("Asia/Singapore")
        : now;
    
      // If pitch is provided, calculate the buffer cutoff time
      if (pitch) {
        const pitchHours = parseInt(pitch, 10);
        nowWithPitch = now.plus({ hours: pitchHours });
      } else {
        // If no pitch is given, disable nothing (since we're only checking buffer)
        return false;
      }
    
      const [startTime, endTime] = slotTime.split("-").map((time) => time.trim());
      const slotStartTime = parseTimeToSingapore(startTime, currentDate);
    
      // Only disable if the slot starts before the buffer cutoff time
      return slotStartTime < nowWithPitch;
    };






  function checkIfTimeFitsInRangeoforDay(
    availableRangeStart,
    availableRangeEnd,
    timeToCheck
  ) {
    if (!timeToCheck) {
      return false;
    }
    if (availableRangeEnd.startsWith("23:59")) {
      availableRangeEnd = "24:00:00";
    }

    const convert24HourToMinutes = (time) => {
      let [hours, minutes, seconds] = time.split(":").map(Number);
      return hours * 60 + minutes + seconds / 60;
    };

    const convert12HourToMinutes = (time) => {
      let [timePart, modifier] = time.split(" ");
      let [hours, minutes] = timePart.split(":").map(Number);

      if (modifier === "PM" && hours !== 12) {
        hours += 12;
      } else if (modifier === "AM" && hours === 12) {
        hours = 0;
      }

      return hours * 60 + minutes;
    };

    const availableStart = convert24HourToMinutes(availableRangeStart);
    const availableEnd = convert24HourToMinutes(availableRangeEnd);
    const [startTime, endTime] = timeToCheck.split("-").map((t) => t.trim());
    const startMinutes = convert12HourToMinutes(startTime);
    const endMinutes = convert12HourToMinutes(endTime);

    const adjustedEndMinutes =
      endMinutes < startMinutes ? endMinutes + 24 * 60 : endMinutes;

    const fitsInRange =
      startMinutes >= availableStart && adjustedEndMinutes <= availableEnd;

    return fitsInRange;
  }

  const headingBoxStyle = {
    width: "170px",
    height: "35px",
    border: "1px solid #ccc",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "5px",
  };

  const boxStyleweeks = {
    width: "150px",
    height: "auto",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    margin: "5px",
  };

  return (
    <div className="flex ml-20 items-center mb-12 week-calender">
      <div className="week-internal">
        <div className="mb-4 text-w week-internal-section">
          <div className="flex text-white">
            <div className="flex-col time-col-week">
              <div className="flex justify-end">
                {/* pv commented this out so that customers cannot go beyond date limit
                <div
                  className="headingBoxStyle arrow-left"
                  style={{ width: "30px", cursor: "pointer" }}
                  onClick={prevWeek}
                >
                  {"<"}
                </div>
                */}
              </div>
            </div>
            <div>
              <div className="flex">
                {[...Array(7)].map((_, index) => (
                  <div
                    key={index}
                    style={{ ...headingBoxStyle, width: boxStyleweeks.width }}
                    className="headingBoxStyle"
                  >
                    {formatDateToDayMonth(
                      new Date(
                        startDate.getFullYear(),
                        startDate.getMonth(),
                        startDate.getDate() + index
                      )
                    )}
                  </div>
                ))}
                {/* pv commented this out so that customers cannot go beyond date limit
                <div
                  key={">"}
                  className="headingBoxStyle arrow-right"
                  style={{ width: "30px", cursor: "pointer" }}
                  onClick={nextWeek}
                >
                  {">"}
                </div>
                */}
              </div>
              <div>
                {[
                  ...Array(
                    newTimeWithslotsWeek?.reduce((maxLength, current) => {
                      return Math.max(maxLength, current.gaps.length);
                    }, 0)
                  ),
                ].map((_, blockIndex) => (
                  <div key={blockIndex} className="flex  mb-4">
                    {[...Array(7)].map((_, dayIndex) => {
                      const isPitchAvailableday =
                        pitchWeekAvailability[
                          getDayOfWeek(
                            formatDate(
                              new Date(
                                startDate.getFullYear(),
                                startDate.getMonth(),
                                startDate.getDate() + dayIndex
                              )
                            )
                          )
                        ];
                      const formattedDate = new Date(
                        startDate.getFullYear(),
                        startDate.getMonth(),
                        startDate.getDate() + dayIndex + 1
                      )
                        .toISOString()
                        .split("T")[0];

                      const isPitchAvailable =
                        newTimeWithslotsWeek?.[dayIndex]?.gaps?.[blockIndex]
                          ?.type === "gap" ||
                        (isPitchAvailableday &&
                          !isPitchAvailableday.some((slot) => {
                            return checkIfTimeFitsInRangeoforDay(
                              slot.start_time,
                              slot.end_time,
                              formatTimeRangespace(
                                newTimeWithslotsWeek?.[dayIndex]?.gaps?.[
                                  blockIndex
                                ]?.range
                              )
                            );
                          }));
                      const is8A = selectedPitchName?.consecutive_pitch;

                      return (
                        <>
                          {!newTimeWithslotsWeek?.[dayIndex]?.gaps?.[blockIndex]
                            ?.range ? (
                            <div className="boxStyleWeeks empty-div flex-col mb-3 mt-3">
                              {/* No Slots <br></br> Available */}
                            </div>
                          ) : (
                            <div
                              key={dayIndex}
                              style={boxStyleweeks}
                              className="boxStyleWeeks flex-col mb-3 mt-3"
                            >
                             <div className="block text-sm w-full flex justify-center time-slot">
  {convertTo24HourFormat(newTimeWithslotsWeek?.[dayIndex]?.gaps?.[blockIndex]?.range)}
</div>

                              {visiblePitches.map((pitch, pitchIndex) => {
                                const alreadyBooked = isSlotAlreadyBooked(
                                  pitch,
                                  formatTimeRangespace(
                                    newTimeWithslotsWeek?.[dayIndex]?.gaps?.[
                                      blockIndex
                                    ]?.range
                                  ),
                                  true,
                                  new Date(
                                    startDate.getFullYear(),
                                    startDate.getMonth(),
                                    startDate.getDate() + dayIndex
                                  )
                                );

                                const isDisabledByTime =
                                  isSlotDisabledByTodayTime(
                                    formatTimeRangespace(
                                      newTimeWithslotsWeek?.[dayIndex]?.gaps?.[
                                        blockIndex
                                      ]?.range
                                    ),
                                    pitch.booking_allowed_after_hrs,
                                    true,
                                    new Date(
                                      startDate.getFullYear(),
                                      startDate.getMonth(),
                                      startDate.getDate() + dayIndex
                                    )
                                  ); 

                                  const isSlotInBuffer = isSlotInBufferPeriod(
                                    formatTimeRangespace(
                                      newTimeWithslotsWeek?.[dayIndex]?.gaps?.[
                                        blockIndex
                                      ]?.range
                                    ),
                                    pitch.booking_allowed_after_hrs,
                                    true,
                                    new Date(
                                      startDate.getFullYear(),
                                      startDate.getMonth(),
                                      startDate.getDate() + dayIndex
                                    )
                                  )

                                const backgroundColor = isSlotSelectedInCart(
                                  pitch,
                                  formatTimeRangespace(
                                    newTimeWithslotsWeek?.[dayIndex]?.gaps?.[
                                      blockIndex
                                    ]?.range
                                  ),
                                  true,
                                  new Date(
                                    startDate.getFullYear(),
                                    startDate.getMonth(),
                                    startDate.getDate() + dayIndex
                                  )
                                )
                                ? "green"
                                : alreadyBooked ||
                                  isPitchAvailable ||
                                  isDisabledByTime
                                ? "lightgrey"
                                : isSlotInBuffer
                                ? "pink"
                                : "white";

                                const isPinkSlot = backgroundColor === 'pink';

                                return (
                                  <div
                                    key={pitchIndex}
                                    className={`pitch-week-box-style mb-2`}
                                    style={{
                                      backgroundColor: backgroundColor,
                                      cursor: isSlotDeleatable(
                                        pitch,
                                        formatTimeRangespace(
                                          newTimeWithslotsWeek?.[dayIndex]
                                            ?.gaps?.[blockIndex]?.range
                                        ),
                                        true,
                                        new Date(
                                          startDate.getFullYear(),
                                          startDate.getMonth(),
                                          startDate.getDate() + dayIndex
                                        )
                                      )
                                        ? "pointer"
                                        : isSlotSelectedInCart(
                                            pitch,
                                            formatTimeRangespace(
                                              newTimeWithslotsWeek?.[dayIndex]
                                                ?.gaps?.[blockIndex]?.range
                                            ),
                                            true,
                                            new Date(
                                              startDate.getFullYear(),
                                              startDate.getMonth(),
                                              startDate.getDate() + dayIndex
                                            )
                                          ) ||
                                          (is8A && pitchIndex % 3 !== 0)
                                        ? "not-allowed"
                                        : "pointer",
                                      border: isSlotSelectedInCart(
                                        pitch,
                                        formatTimeRangespace(
                                          newTimeWithslotsWeek?.[dayIndex]
                                            ?.gaps?.[blockIndex]?.range
                                        ),
                                        true,
                                        new Date(
                                          startDate.getFullYear(),
                                          startDate.getMonth(),
                                          startDate.getDate() + dayIndex
                                        )
                                      )
                                        ? "1px solid green"
                                        : alreadyBooked ||
                                          isPitchAvailable ||
                                          isDisabledByTime
                                        ? "1px solid #8F8F8F"
                                        : isSlotInBuffer 
                                        ? "1px solid #FFB6C1"
                                        : "",
                                      width: "auto",
                                      position: 'relative'
                                    }}
                                    onMouseEnter={() => {
                                      if (isPinkSlot) {
                                        setHoveredPitch(pitch);
                                        setHoveredTimeRange(formatTimeRangespace(
                                          newTimeWithslotsWeek?.[dayIndex]?.gaps?.[blockIndex]?.range
                                        ));
                                        setHoveredDate(new Date(
                                          startDate.getFullYear(),
                                          startDate.getMonth(),
                                          startDate.getDate() + dayIndex
                                        ));
                                      }
                                    }}
                                    onMouseLeave={() => {
                                      setHoveredPitch(null);
                                      setHoveredTimeRange(null);
                                      setHoveredDate(null);
                                    }}
                                  >
                                    <div
                                      className="sm:text-small flex"
                                      onClick={() => {
                                        if (is8A && pitchIndex % 3 !== 0) {
                                        } else if (
                                          !(
                                            alreadyBooked ||
                                            isPitchAvailable ||
                                            isDisabledByTime ||
                                            isSlotInBuffer
                                          )
                                        ) {
                                          isSlotSelectedInCart(
                                            pitch,
                                            formatTimeRangespace(
                                              newTimeWithslotsWeek?.[dayIndex]
                                                ?.gaps?.[blockIndex]?.range
                                            ),
                                            true,
                                            new Date(
                                              startDate.getFullYear(),
                                              startDate.getMonth(),
                                              startDate.getDate() + dayIndex
                                            )
                                          ) &&
                                          isSlotDeleatable(
                                            pitch,
                                            formatTimeRangespace(
                                              newTimeWithslotsWeek?.[dayIndex]
                                                ?.gaps?.[blockIndex]?.range
                                            ),
                                            true,
                                            new Date(
                                              startDate.getFullYear(),
                                              startDate.getMonth(),
                                              startDate.getDate() + dayIndex
                                            )
                                          )
                                            ? removeFromCart(
                                                pitch.name,
                                                formatTimeRangespace(
                                                  newTimeWithslotsWeek?.[
                                                    dayIndex
                                                  ]?.gaps?.[blockIndex]?.range
                                                ),
                                                formatDate(
                                                  new Date(
                                                    startDate.getFullYear(),
                                                    startDate.getMonth(),
                                                    startDate.getDate() +
                                                      dayIndex
                                                  )
                                                )
                                              )
                                            : console.log(pitch, "boxclick");
                                          handleBoxClick(
                                            pitch,
                                            newTimeWithslotsWeek?.[dayIndex]
                                              ?.gaps?.[blockIndex]?.range,
                                            true,
                                            new Date(
                                              startDate.getFullYear(),
                                              startDate.getMonth(),
                                              startDate.getDate() + dayIndex
                                            )
                                          );
                                        }
                                      }}
                                    >
                                      <div
                                        className="pitch-name-week"
                                        style={{
                                          color: isSlotSelectedInCart(
                                            pitch,
                                            formatTimeRangespace(
                                              newTimeWithslotsWeek?.[dayIndex]
                                                ?.gaps?.[blockIndex]?.range
                                            ),
                                            true,
                                            new Date(
                                              startDate.getFullYear(),
                                              startDate.getMonth(),
                                              startDate.getDate() + dayIndex
                                            )
                                          )
                                            ? "white"
                                            : alreadyBooked ||
                                              isPitchAvailable ||
                                              isDisabledByTime
                                            ? "#8F8F8F"
                                            : "green",
                                        }}
                                      >
                                         
                                      </div>
                                       {/* <img
                                            src={selectedPitchIcon}
                                            alt="Pitch icon"
                                            className="w-4 h-4"
                                            style={{
                                              filter: isSlotSelectedInCart(
                                                pitch,
                                                formatTimeRangespace(
                                                  newTimeWithslotsWeek?.[dayIndex]?.gaps?.[blockIndex]?.range
                                                ),
                                                true,
                                                new Date(
                                                  startDate.getFullYear(),
                                                  startDate.getMonth(),
                                                  startDate.getDate() + dayIndex
                                                )
                                              )
                                                ? "hue-rotate(180deg) brightness(200%)"
                                                : alreadyBooked || isPitchAvailable || isDisabledByTime
                                                ? "brightness(90%) saturate(0%)"
                                                : "",
                                            }}
                                          /> */}
                                      <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                                          <span style={{ fontSize: '8px', fontWeight: 'bold' }}>{pitch.pitch_name}</span>
                                         
                                          <span 
                                          style={{
                                            color: 'red',
                                            fontSize: '0.5rem',
                                            fontWeight: 'bold',
                                            marginLeft: '2px'
                                          }}
                                        >
                                          {(() => {
                                            const { duration, unit } = getDurationDisplay(
                                              formatTimeRangespace(
                                                newTimeWithslotsWeek?.[dayIndex]?.gaps?.[blockIndex]?.range
                                              )
                                            );
                                            return `(${duration}${unit})`;
                                          })()}
                                        </span>
                                    </div>
                                    </div>

                                    {/* Tooltip for pink slots */}
                                    {isPinkSlot && hoveredPitch === pitch && hoveredTimeRange === formatTimeRangespace(
                                      newTimeWithslotsWeek?.[dayIndex]?.gaps?.[blockIndex]?.range
                                    ) && (
                                      <div style={{
                                        position: 'absolute',
                                        top: '100%',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        backgroundColor: 'white',
                                        padding: '8px',
                                        borderRadius: '4px',
                                        boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                                        zIndex: 10,
                                        minWidth: '200px',
                                        textAlign: 'center',
                                        marginTop: '5px'
                                      }}>
                                        Call 6344 9345 to make a booking
                                      </div>
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                          )}
                        </>
                      );
                    })}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WeekCalendar;
